import contentTypes from './types'

const initialState = {
  purchasedSeries: [],
  purchasedCommunity: [],
}

const contentReducer = (state = initialState, action) => {
  const { type, payload } = action

  if (type === contentTypes.SET_PURCHASED_SERIES) {
    return {
      ...state,
      purchasedSeries: payload
    }
  }
  
  if (type === contentTypes.SET_PURCHASED_COMMUNITY) {
    return {
      ...state,
      purchasedCommunity: payload
    }
  }
  
  if (type === contentTypes.ADD_TO_PURCHASED_SERIES) {
    return {
      ...state,
      purchasedSeries: [...state.purchasedSeries, payload]
    }
  }
  
  if (type === contentTypes.ADD_TO_PURCHASED_COMMUNITY) {
    return {
      ...state,
      purchasedCommunity: [...state.purchasedCommunity, payload]
    }
  }

  if (type === 'LOGOUT') {
    return initialState
  }

  return state
}

export default contentReducer